import { SET_FILTER_OPTIONS, CLEAR_FILTER_OPTIONS } from "constants/types";

const initialState = {};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_FILTER_OPTIONS:
      return { ...state, [payload.key]: payload.value };
    case CLEAR_FILTER_OPTIONS:
      return initialState;
    default:
      return state;
  }
}
